module.exports = __webpack_public_path__ + "img/stock1.5c593399.png";